import { useState, useContext, FC, useEffect, useCallback } from "react";
import CommentsList from "./CommentsList";
import Actions from "./Actions";
import { AuthContext } from "common/context/Auth";
import Axios from "axios";
import { useRouter } from "next/router";
import { publicationTypes } from "common/context/Publication/PublicationContext";
import { PublicationContext } from "common/context/Publication";
import { ArticleContext } from "../Context";
import { articleTypes } from "../Context/ArticleContext";

interface Props {
  id: string;
}

const Comments: FC<Props> = ({ id }) => {
  const { refactoredArticle } = useContext<articleTypes>(ArticleContext);
  const { publication } = useContext<publicationTypes>(PublicationContext);
  const router = useRouter();
  const { session, attributes } = useContext<any>(AuthContext);
  const [body, setBody] = useState("");
  const [comments, commentsList] = useState<any>([]);

  const fetchComments = async () => {
    try {
      const comments = await Axios.get(`/api/comment/get?id=${id}`);

      if (comments.status === 200) {
        commentsList(comments.data);
      }
    } catch (err) {}
  };

  useEffect(() => {
    fetchComments();
  }, [router.asPath]);

  const addComment = useCallback(async () => {
    try {
      const blockedusers = [
        "77a309dd-0b3e-4ed1-9efb-87b07fdaffd3",
        "a53176ee-037f-4a98-83eb-2b460975fd72",
        "94ff9c24-835b-4c2a-9140-d14cd191cf63"
      ];

      if (blockedusers.includes(session?.username)) {
        return;
      } else {
        const comment = {
          title: refactoredArticle.title,
          publication: publication,
          author: attributes ? attributes[2].Value : "",
          authorid: session?.username,
          authorEmail: attributes.filter(
            (item: any) => item.Name === "email"
          )[0].Value,
          body: body,
          timestamp: Date.now(),
          id,
          users: [],
          articleUrl: router.asPath,
        };

        await Axios.post("/api/comment/post", {
          ...comment,
        });
        commentsList([comment, ...comments]);
        setBody("");
      }
    } catch (err) {
      console.log({ err });
    }
  }, [session, attributes, body]);

  const handleBodyChange = (e: any) => {
    setBody(e.target.value);
  };
  const cancelPost = () => {
    setBody("");
  };

  return (
    <>
      <Actions
        cancelPost={cancelPost}
        session={session}
        handleBodyChange={handleBodyChange}
        body={body}
        addComment={addComment}
      />
      <CommentsList userId={session?.username} comments={comments} />
    </>
  );
};

export default Comments;
